<div class="iot-platform-ui-toolbar-button" data-cy="iot-platform-ui-toolbar-button">
  @if (button().type === IotToolbarButtonType.STATUS_BUTTON) {
    @if (button().displayButton && !(button().disabled && button().removable)) {
      @if (button().customTemplate) {
        <ng-content select="[toolbarCustomStatusButtonItem]"></ng-content>
      } @else {
        <iot-platform-ui-status-button
          cssClassName="{{ 'iot-platform-ui-toolbar-button-' + button().dispatchAction?.type }} {{ button().cssClassName }}"
          (dispatchEvent)="onButtonClick(button().dispatchAction)"
          [color]="button().color"
          [disabled]="button().disabled"
          [matTooltip]="button().tooltip | translate"
          [actionLabel]="button().actionLabel"
          [actionSubLabel]="button().actionSubLabel"
          [displayNestedAction]="button().displayNestedAction"
          [nestedActionLabel]="button().nestedActionLabel"
        />
      }
    }
  } @else if (button().type === IotToolbarButtonType.DIVIDER && button().displayButton) {
    <mat-divider style="height: 32px; margin: 0 4px" [vertical]="true" />
  } @else if (button().type === IotToolbarButtonType.MENU_BUTTON && button().displayButton) {
    <button
      [matMenuTriggerFor]="buttonMenu"
      [disabled]="button().disabled"
      [matTooltip]="button().tooltip | translate"
      class="regular-round-button reverse-accent-button"
      mat-icon-button
      matTooltipClass="regular-tooltip"
      [ngClass]="{ 'iot-platform-ui-toolbar-button__menu-button-with-arrow': button()['displayArrowIcon'] }"
    >
      <mat-icon [svgIcon]="button().svgIcon">{{ button().icon }}</mat-icon>
      @if (button()['displayArrowIcon']) {
        <mat-icon class="iot-platform-ui-toolbar-button__menu-arrow-icon">arrow_drop_down</mat-icon>
      }
    </button>

    <mat-menu #buttonMenu="matMenu">
      @for (menuOption of button().menuOptions; track menuOption.label) {
        @if (!menuOption.hideOption) {
          @if (menuOption?.divider) {
            <mat-divider></mat-divider>
          }
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <button
              (click)="onMenuOptionClick(menuOption.dispatchAction)"
              [disabled]="menuOption.disableOption"
              [matTooltip]="menuOption.tooltip ?? '' | translate"
              matTooltipClass="regular-tooltip"
              mat-menu-item
            >
              <span [style]="menuOption.style">{{ menuOption.label | translate }}</span>
            </button>

            <ng-container [ngTemplateOutlet]="tmplValueMeta" [ngTemplateOutletContext]="{ options: menuOption }" />
          </div>
        }
      }
    </mat-menu>
  } @else if (button().displayButton && !(button().disabled && button().removable)) {
    <button
      (click)="onButtonClick(button().dispatchAction)"
      [class]="'regular-round-button reverse-accent-button iot-platform-ui-toolbar-button-' + button().dispatchAction?.type"
      [disabled]="button().disabled"
      [matTooltip]="button().tooltip | translate"
      [ngClass]="computedClasses()"
      mat-icon-button
      matTooltipClass="regular-tooltip"
    >
      <mat-icon
        [svgIcon]="button().svgIcon"
        [matBadge]="button().badge === '' ? '&#8288;' : button().badge"
        matBadgeSize="small"
        aria-hidden="false"
        [matBadgeColor]="button().badgeColor"
        >{{ button().icon }}</mat-icon
      >
    </button>
  }
</div>

<ng-template #tmplValueMeta let-options="options">
  @if (options?.valueMeta?.icon) {
    @if (!!options?.valueMeta?.visibleExpression) {
      @if (options?.valueMeta?.visibleExpression?.($safeNavigationMigration(options?.data))) {
        <mat-icon
          [class]="'iot-platform-ui-toolbar-button__value-meta-icon iot-platform-ui-toolbar-button__value-meta-icon--' + button().dispatchAction?.type"
          [matTooltip]="$safeNavigationMigration(options?.valueMeta?.tooltip) | translate"
          matTooltipClass="regular-tooltip"
          >{{ options?.valueMeta?.icon }}
        </mat-icon>
      }
    } @else {
      <mat-icon
        [class]="'iot-platform-ui-toolbar-button__value-meta-icon iot-platform-ui-toolbar-button__value-meta-icon--' + button().dispatchAction?.type"
        [matTooltip]="$safeNavigationMigration(options?.valueMeta?.tooltip) | translate"
        matTooltipClass="regular-tooltip"
        >{{ options?.valueMeta?.icon }}
      </mat-icon>
    }
  }
</ng-template>
